<img [src]="src" [alt]="alt" (error)="getAlternateImage($event)"/>
